// src/hooks/useAddBattle.js
import { useState } from "react";
import { addBattle } from "../api/battleApi";

export function useAddBattle() {
  const [submitting, setSubmitting] = useState(false);

  const submitBattle = async (battleData) => {
    setSubmitting(true);
    try {
      const res = await addBattle(battleData);
      return res.data.battleId; // 필요하면 반환값 활용
    } catch (e) {
      console.error("addBattle error:", e);
      throw e;
    } finally {
      setSubmitting(false);
    }
  };

  return { submitting, submitBattle };
}
